
import Vue from 'vue';
import EventBus from '@/plugins/event-bus';
import CustomFile from '@/components/Common/CustomFile.vue';
import CambioNombreComercialService from '@/services/CambioNombreComercialService';
import rules from '@/mixins/rules';

export default Vue.extend({
    name: 'CambioNombreComercial',
    mixins: [rules],
    components: {
        CustomFile,
    },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        locacion: {
            type: Object,
            default: null as any,
        },
        deleteSolicitud: {
            type: Boolean,
            default: false,
        },
        disabledForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            disabled: false,
            dialogBusqueda: false,
            dialogDelete: false,
            dialog: false,
            form: {
                id: '',
                nuevo_nombre_comercial: '',
                documentos: {
                    'scd_identificacion': {
                        code: 'scd_identificacion',
                        file: '',
                        binary: '',
                        data: null,
                    },
                    'scd_constancia': {
                        code: 'scd_constancia',
                        file: '',
                        binary: '',
                        data: null,
                    },
                }
            },
            solicitud: {} as any,
        }
    },
    watch: {
        open() {
            if (this.open == true) {
                this.getData();
            }
        },
        disabledForm() {
            this.disabled = this.disabledForm;
        }
    },
    methods: {
        close() {
            this.$emit('closeCambioNombreComercial');
            this.clearForm();
            this.dialog = false;
        },
        clearForm() {
            this.form = {
                id: '',
                nuevo_nombre_comercial: '',
                documentos: {
                    'scd_identificacion': {
                        code: 'scd_identificacion',
                        file: '',
                        binary: '',
                        data: null,
                    },
                    'scd_constancia': {
                        code: 'scd_constancia',
                        file: '',
                        binary: '',
                        data: null,
                    },
                }
            }
        },
        async save() {
            // @ts-ignore
            let validate = this.$refs.form.validate();
            if (validate) {
                this.disabled = true;
                const formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('nuevo_nombre_comercial', this.form.nuevo_nombre_comercial);
                CambioNombreComercialService.cambioNombreComercialExtra(this.locacion.id, formData)
                    .then((response) => {
                        if (response.data.success) {
                            this.$toast.success(response.data.message);
                            this.$emit('reloadData');
                            this.getData();
                        } else {
                            this.$toast.error(response.data.message);
                        }
                        this.disabled = false;
                    })
                    .catch((error) => {
                        //this.$toast.error(error.response.data.message);
                        this.disabled = false;
                    });
            } else {
                this.$toast.warning('Por favor, completa los campos obligatorios');
            }
        },
        getData() {
            this.dialog = true;
            CambioNombreComercialService.getCambioNombreComercialExtra(this.locacion.id)
            .then((response) => {
                let solicitud = response.data;
                this.solicitud = solicitud;
                if (solicitud) {
                    this.form.id = solicitud.id;
                    this.form.nuevo_nombre_comercial = solicitud.nuevo_nombre_comercial;
                    if (solicitud.estatus_id == 10) {
                        this.disabled = true;
                    }

                    if (this.deleteSolicitud) {
                        this.dialogDelete = true;
                    }
                }
            })
        },
        updateCambioNombreComercial() {
            // @ts-ignore
            let validate = this.$refs.form.validate();
            if (validate) {
                this.disabled = true;
    
                const formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('nuevo_nombre_comercial', this.form.nuevo_nombre_comercial);
                CambioNombreComercialService.updateCambioNombreComercialExtra(this.locacion.id, this.form.id, formData)
                .then((response) => {
                    if (response.data.success) {
                        this.$toast.success(response.data.message);
                        this.$emit('reloadData');
                        this.getData();
                    } else {
                        this.$toast.error(response.data.message);
                    }
                    this.disabled = false;
                })
                .catch((error) => {
                    //this.$toast.error(error.response.data.message);
                    this.disabled = false;
                });
            } else {
                this.$toast.warning('Por favor, completa los campos obligatorios');
            }
        },
        deleteCambioNombreComercialExtra() {
            CambioNombreComercialService.deleteCambioNombreComercialExtra(this.locacion.id, this.form.id, {})
            .then((response) => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.$emit('reloadData');
                    this.close();
                    this.dialogDelete = false;
                } else {
                    this.$toast.error(response.data.message);
                }
                this.disabled = false;
            })
            .catch((error) => {
                //this.$toast.error(error.response.data.message);
                this.disabled = false;
            });
        },
    },
})
